import { render, staticRenderFns } from "./ZipperIcon.vue?vue&type=template&id=e326fbf6&"
import script from "./ZipperIcon.vue?vue&type=script&lang=js&"
export * from "./ZipperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports